import { useGetCompanyDetailsQuery } from "web/features/company/companyApiSlice";

const useIsDashboardHeaderEnabled = () => {
  const { data: company, isLoading } = useGetCompanyDetailsQuery();
  const isDashboardHeaderEnabled = company?.enableDashboardHeader;

  return { isLoading, isDashboardHeaderEnabled };
};

export default useIsDashboardHeaderEnabled;
